import { Client, Storage } from "appwrite";

const client = new Client();

// Configure your Appwrite endpoint and project ID
client
  .setEndpoint(process.env.REACT_APP_APPWRITE_ENDPOINT )
  .setProject(process.env.REACT_APP_APPWRITE_PROJECT_ID );

const storage = new Storage(client);

// Storage bucket ID - you'll need to create this in your Appwrite console
const BUCKET_ID = process.env.REACT_APP_APPWRITE_BUCKET_ID ;

export { client, storage, BUCKET_ID };
